<template>
  <div>
    <b-modal id="segmentsModal" ref="makeSegmentsModal" class="segments-modal" @hidden="onModalHidden">
      <div slot="modal-header">
        <span class="modal-title">
          {{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.title')}}
        </span>
      </div>

      <form ref="segmentForm" class="modal-body chart-segment-modal" @submit.prevent="onSegmentFormSubmitted">
        <div class="form-group">
          <label class="control-label control-label-default">
            {{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.name')}}
          </label>
    
          <input 
            v-validate="validationRules.name"
            :class="{'error-input': (errors.has('name') && formSubmitted)}"
            class="form-control form-control-default" 
            v-model="segment.name" 
            type="text" 
            name="name" />
          <div class="error error-message" v-show="(errors.has('name') && formSubmitted)">
            {{ errors.first('name') }}
          </div>
        </div>
        <div class="form-group">
          <label class="control-label control-label-default">
            {{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.start')}}: 
          </label>
          
          <div class="form-input-wrapper form-control-default">
            <input 
              class="form-control inline-input form-control-default" 
              v-model="segment.startMinutes" 
              :class="{'error-input': (errors.has('startMinutes') && formSubmitted)}"
              v-validate="validationRules.startMinutes"
              type="number" 
              name="startMinutes" 
              :placeholder="$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.minutes')"
              autofocus/>

              <span class="inside-label">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.min')}}</span>
          </div>

          <div class="form-input-wrapper form-control-default">
            <input 
              class="form-control inline-input form-control-default" 
              v-model="segment.startSeconds" 
              :class="{'error-input': (errors.has('startSeconds') && formSubmitted)}"
              v-validate="validationRules.startSeconds"
              type="number" 
              :placeholder="$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.seconds')"
              name="startSeconds" 
              autofocus/>

              <span class="inside-label">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.sec')}}</span>
          </div>

          <div class="error error-message" v-show="(errors.has('startMinutes') && formSubmitted)">
            {{ errors.first('startMinutes') }}
          </div>

          <div class="error error-message" v-show="(errors.has('startSeconds') && formSubmitted)">
            {{ errors.first('startSeconds') }}
          </div>
        </div>
    
        <div class="form-group">
          <label class="control-label control-label-default">
            {{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.end')}}: 
          </label>

          <div class="form-input-wrapper form-control-default">
            <input 
              class="form-control form-control-default inline-input" 
              v-model="segment.endMinutes" 
              :class="{'error-input': (errors.has('endMinutes') && formSubmitted)}"
              v-validate="validationRules.endMinutes"
              type="number" 
              name="endMinutes" 
              :placeholder="$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.minutes')"
              autofocus />

            <span class="inside-label">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.min')}}</span>
          </div>
          <div class="form-input-wrapper form-control-default">
            <input 
              class="form-control form-control-default inline-input" 
              v-model="segment.endSeconds"
              :class="{'error-input': (errors.has('endSeconds') && formSubmitted)}"
              v-validate="validationRules.endSeconds"
              type="number" 
              name="endSeconds" 
              :placeholder="$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.seconds')"
              autofocus />

              <span class="inside-label">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.sec')}}</span>
          </div>

          <div class="error error-message" v-show="(errors.has('endMinutes') && formSubmitted)">
            {{ errors.first('endMinutes') }}
          </div>

          <div class="error error-message" v-show="(errors.has('endSeconds') && formSubmitted)">
            {{ errors.first('endSeconds') }}
          </div>
        </div>
      </form>
        
      <div slot="modal-footer" class="w-100">
        <button type="button" class="btn btn-type-3" @click="closeModal">{{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.cancel')}}</button>
        <button 
          v-loading-button="loadingForm"
          type="button" 
          class="btn btn-type-4" 
          :class="{ 'loading': uploadInProgress }"
          :disabled="uploadInProgress"
          @click.prevent="onSegmentFormSubmitted">
          <span>
            {{ $t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.create')}}
          </span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { TOASTER_ERROR } from "@/common/events.types";

export default {
  name: 'MakeSegmentModal',
  props: [
    'showModal',
    'selection',
    'segmentNumber',
    'maxValue',
    'creationCommited',
    'creationCanceled',
    'modalHidden',
    'loadingForm'
  ],
  data () {
    return {
      formSubmitted: false,
      uploadInProgress: false,
      validationRules: {
        name: 'max:64|min:0|required',
        startMinutes: {
          regex: /^[0-9]*$/
        },
        endMinutes: {
          regex: /^[0-9]*$/
        },
        startSeconds: {
          regex: /^[0-9]*$/
        },
        endSeconds: {
          regex: /^[0-9]*$/
        }
      },
      segment: {
        name: '',
        startMinutes: '',
        endMinutes: '',
        startSeconds: '',
        endSeconds: '',
      }
    }
  },
  methods: {
    closeModal () {
      this.$refs.makeSegmentsModal.hide();
      this.creationCanceled();
    },
    onModalHidden () {
      this.modalHidden();
      this.uploadInProgress = false
    },
    onSegmentFormSubmitted () {
      const context = this;

      this.$validator.validateAll().then(result => {
        this.formSubmitted = true;

        if(result) {
          const startPoint = parseInt(context.segment.startSeconds) + (parseInt(context.segment.startMinutes) * 60);
          const endPoint = parseInt(context.segment.endSeconds) + (parseInt(context.segment.endMinutes) * 60);
          const maxValueSeconds = context.maxValue * 60;

          if((context.segment.startSeconds === null && context.segment.startMinutes === null) || 
                (context.segment.endSeconds === null && context.segment.endMinutes === null)) {

            context.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.errorValidData')
            });
            return;
          }

          if(isNaN(startPoint) || isNaN(endPoint)) {
            context.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.errorValidData')
            });

            return;
          }

          if((endPoint - startPoint) < 10) {
            context.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.errorLess10')
            });

            return;
          }

          if(endPoint > maxValueSeconds || startPoint > maxValueSeconds) {
            context.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.errorOutScope')
            });

            return;
          } 
          
          context.creationCommited({ 
            startPoint,
            endPoint,
            name: this.segment.name
          });
        }
      });
    },
    submitFormOnClick () {
      this.$refs.segmentForm.submit()
    }
  },
  watch: {
    showModal (newValue, oldValue) {
      if(newValue) {
        this.$refs.makeSegmentsModal.show();
      } else {
        this.$refs.makeSegmentsModal.hide();
      }
    },
    selection (newValue) {
      if(newValue) {
        const start = newValue.start * 60;
        const end = newValue.end * 60;

        this.segment.name = this.$t('CALENDAR_ACTIVITY.playerStatsTables.hrStatsTable.segmentModal.segmentName') + ' ' + this.segmentNumber;
        this.segment.startMinutes = Math.floor(start / 60);
        this.segment.endMinutes = Math.floor(end / 60);
        this.segment.startSeconds = Math.floor(start - (this.segment.startMinutes * 60));
        this.segment.endSeconds = Math.floor(end - (this.segment.endMinutes * 60));
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart-segment-modal {
    .form-input-wrapper {
      display: inline-block;
      border-radius: 4px;
      position: relative;
      width: calc(50% - 5px);

      &:first-of-type {
        margin-right: 10px;
      }

      .inline-input {
        padding-right: 40px;
      }

      input {
        margin-right: 0;
      }

      .inside-label {
        position: absolute;
        right: 5px;
        top: 0;
        bottom: 0;
        height: 19px;
        margin: auto;
        color: $elephant-gray;
        font-weight: 300;
      }
    }

    .error {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .modal-footer {
    .btn:last-child {
      margin-left: 5px;
    }
  }
</style>
